module.exports = "<ng-template #QRModal let-c=\"close\" let-d=\"dismiss\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body qr-modal-body\">\n    <img class=\"qr-modal-image img-responsive\" [src]=\"qrImageUrl\" *ngIf=\"qrImageUrl\"/>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn blue\" (click)=\"print()\">Imprimir</button>\n  </div>\n</ng-template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/shared/components/qr-modal/qr-modal.component.html
// module id = 596
// module chunks = 8